export default "__VITE_ASSET__BdsAXpQw__"